export default {
    HISTORY_GET_LIST: 'HISTORY_GET_LIST',
    HISTORY_GET_LIST_SUCCESS: 'HISTORY_GET_LIST_SUCCESS',
    HISTORY_GET_LIST_FAIL: 'HISTORY_GET_LIST_FAIL',
    HISTORY_CLEAN_DATA: 'HISTORY_CLEAN_DATA',
}
